<tui-data-list class="menu-list">
  <ng-container *ngFor="let item of items">
    <button *ngIf="getVisibleItem(item)" tuiOption class="menu-list__item" (click)="onClickItem($event, item)">
      <app-icon *ngIf="item.icon !== ''" [color]="item.color ?? 'var(--tui-text-action)'" [src]="item.icon"></app-icon>
      {{ item.title | translate }}
    </button>
  </ng-container>
</tui-data-list>
